import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  async getAll($) {
    const path = `/business/products`
    let results = (await HTTP.get(path)).data
    return results
  },

  async getprincipalAll() {
    const path = `/business/products/principal`
    let results = (await HTTP.get(path)).data
    return results
  },

  async get(productId) {
    const path = `/business/products/${productId}`
    return (await HTTP.get(path)).data
  },

  async post(notification_object) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/products`, notification_object)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async authorize(productId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/products/${productId}/approved`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async reject(productId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`business/products/${productId}/rejected`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/business/products/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(productId) {
    const path = `/business/products/${productId}`
    return (await HTTP.delete(path)).data
  }
}
